
export default function AgeGroupSection() {
  const ageGroups = [
    {
      age: "0-2 Yaş",
      title: "Bebekler",
      description: "Sağlıklı büyüme ve gelişim için özel formüller",
      image:
        "https://readdy.ai/api/search-image?query=healthy%20happy%20baby%20aged%206%20months%20to%202%20years%20old%2C%20cute%20infant%20smiling%2C%20bright%20clean%20background%20with%20soft%20pastel%20colors%2C%20professional%20child%20photography%20showing%20wellness%20and%20health%2C%20natural%20lighting%2C%20joyful%20expression%2C%20high%20quality%20lifestyle%20image%20for%20health%20supplements&width=400&height=500&seq=age1&orientation=portrait",
      products: ["D3 Vitamini", "Probiyotik Damla", "Omega-3 Damla"],
      color: "from-pink-50 to-pink-100",
    },
    {
      age: "3-6 Yaş",
      title: "Okul Öncesi",
      description: "Bağışıklık sistemi güçlendirici takviyeler",
      image:
        "https://readdy.ai/api/search-image?query=happy%20preschool%20child%20aged%203%20to%206%20years%20old%20playing%20and%20smiling%2C%20energetic%20kid%20in%20bright%20colorful%20environment%2C%20professional%20child%20photography%20showing%20health%20and%20vitality%2C%20natural%20outdoor%20setting%2C%20joyful%20active%20lifestyle%2C%20high%20quality%20image%20for%20children%20health%20products&width=400&height=500&seq=age2&orientation=portrait",
      products: ["Çoklu Vitamin", "C Vitamini", "Çinko Takviyesi"],
      color: "from-cyan-50 to-cyan-100",
    },
    {
      age: "7-12 Yaş",
      title: "İlkokul Çağı",
      description: "Zihinsel ve fiziksel gelişim destekleyiciler",
      image:
        "https://readdy.ai/api/search-image?query=school%20age%20child%20aged%207%20to%2012%20years%20old%20studying%20and%20smiling%2C%20confident%20elementary%20student%2C%20bright%20educational%20environment%2C%20professional%20child%20photography%20showing%20concentration%20and%20health%2C%20natural%20lighting%2C%20positive%20energy%2C%20high%20quality%20lifestyle%20image%20for%20kids%20supplements&width=400&height=500&seq=age3&orientation=portrait",
      products: ["Omega-3", "B Kompleks", "Magnezyum"],
      color: "from-green-50 to-green-100",
    },
    {
      age: "13-16 Yaş",
      title: "Ergenlik Dönemi",
      description: "Büyüme çağı için özel destekler",
      image:
        "https://readdy.ai/api/search-image?query=teenage%20youth%20aged%2013%20to%2016%20years%20old%2C%20healthy%20adolescent%20smiling%20confidently%2C%20active%20lifestyle%20with%20sports%20equipment%2C%20professional%20photography%20showing%20teenage%20wellness%20and%20vitality%2C%20bright%20natural%20setting%2C%20energetic%20atmosphere%2C%20high%20quality%20image%20for%20teen%20health%20supplements&width=400&height=500&seq=age4&orientation=portrait",
      products: ["Kolajen", "Demir", "Kalsiyum"],
      color: "from-amber-50 to-amber-100",
    },
  ];

  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Her Yaş Grubuna Özel Ürünler
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Bebeklikten ergenliğe, her yaş grubunun ihtiyaçlarına uygun, uzman onaylı takviye gıdalar
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {ageGroups.map((group, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md sm:shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-36 sm:h-52 md:h-64 lg:h-80 overflow-hidden">
                <img
                  src={group.image}
                  alt={group.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${group.color} opacity-40`}></div>
                <div className="absolute top-2 sm:top-3 md:top-4 left-2 sm:left-3 md:left-4 bg-white px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full shadow-md">
                  <span className="font-bold text-brand-600 text-[10px] sm:text-xs md:text-sm">{group.age}</span>
                </div>
              </div>

              <div className="p-3 sm:p-4 md:p-6 space-y-2 sm:space-y-3 md:space-y-4">
                <h3 className="text-sm sm:text-base md:text-xl font-bold text-gray-900">{group.title}</h3>
                <p className="text-[10px] sm:text-xs md:text-sm text-gray-600 line-clamp-2">{group.description}</p>

                <div className="space-y-1.5 sm:space-y-2">
                  <div className="text-[9px] sm:text-[10px] md:text-xs font-semibold text-gray-500 uppercase">
                    Önerilen Ürünler:
                  </div>
                  <div className="flex flex-wrap gap-1 sm:gap-1.5 md:gap-2">
                    {group.products.map((product, idx) => (
                      <span
                        key={idx}
                        className="text-[9px] sm:text-[10px] md:text-xs bg-brand-50 text-brand-700 px-1.5 sm:px-2 md:px-3 py-0.5 sm:py-1 rounded-full"
                      >
                        {product}
                      </span>
                    ))}
                  </div>
                </div>

                <button className="w-full bg-brand-600 text-white py-2 sm:py-2.5 md:py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors whitespace-nowrap text-[10px] sm:text-xs md:text-sm">
                  Ürünleri Gör
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
